import { errorThatWillCauseAlertAndThrow } from "owa-trace";
import { type LocalStorageKeys } from "../util/LocalStorageKeys";

export type LocalStorageSetItemCb = (key: LocalStorageKeys, value: string) => void;
export type LocalStorageRemoveItemCb = (key: LocalStorageKeys) => void;
export type LocalStorageGetItemCb = (key: LocalStorageKeys) => Promise<string | null>;

let localStorageSetItemCb: LocalStorageSetItemCb;
let localStorageRemoveItemCb: LocalStorageRemoveItemCb;
let localStorageGetItemCb: LocalStorageGetItemCb;

// Store local storage callbacks from main thread in memory on Web Worker thread for future use
export function setLocalStorageCallbacks(setItemCb: LocalStorageSetItemCb, removeItemCb: LocalStorageRemoveItemCb, getItemCb: LocalStorageGetItemCb): void {
    localStorageSetItemCb = setItemCb;
    localStorageRemoveItemCb = removeItemCb;
    localStorageGetItemCb = getItemCb;
}

// Web Worker doesn't have access to LocalStorage, so we mock it with WorkerStorageData
// which uses this function to set items in local storage
export function setLocalStorageItem(key: LocalStorageKeys, value: string): void {
    if (!localStorageSetItemCb) {
        /* eslint-disable-next-line owa-custom-rules/no-error-dynamic-event-names -- (https://aka.ms/OWALintWiki)
         * The error name (message) must be a string literal (no variables in it).
         *	> Error names can only be a string literals. Use the diagnosticInfo to add custom data. */
        errorThatWillCauseAlertAndThrow("NoLocalStorageSetCallbackDefinedInWorker " + key);
    }
    
    localStorageSetItemCb(key, value);
}

// Web Worker doesn't have access to LocalStorage, so we mock it with WorkerStorageData
// which uses this function to remove items from local storage
export function removeLocalStorageItem(key: LocalStorageKeys): void {
    if (!localStorageRemoveItemCb) {
        /* eslint-disable-next-line owa-custom-rules/no-error-dynamic-event-names -- (https://aka.ms/OWALintWiki)
         * The error name (message) must be a string literal (no variables in it).
         *	> Error names can only be a string literals. Use the diagnosticInfo to add custom data. */
        errorThatWillCauseAlertAndThrow("NoLocalStorageRemoveCallbackDefinedInWorker " + key);
    }
    
    localStorageRemoveItemCb(key);
}

export function getLocalStorageItem(key: LocalStorageKeys): Promise<string | null> {
    if (!localStorageGetItemCb) {
        errorThatWillCauseAlertAndThrow("NoLocalStorageGetCallbackDefinedInWorker");
    }
    
    return localStorageGetItemCb(key);
}
